import React from 'react';

import { useGroupState, useGroupActions } from './GroupContext';
import { createGroup } from './restApi';
import Form from '../../Shared/UI/Form/components/Form';
import Field from '../../Shared/UI/Field/components/Field';
import Input from '../../Shared/UI/Input/components/Input';
import Textarea from '../../Shared/UI/Textarea/components/Textarea';
import FileInput from '../../Shared/UI/FileInput/components/FileInput';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Button from '../../Shared/UI/Button/components/Button';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';

const GroupForm = () => {
  const state = useGroupState();
  const { onResponse, onError, updateGroupFormImage, updateGroupFormName, updateGroupFormDescription, closeGroupModal } = useGroupActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const base64Image = (image) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64String = reader.result
        .replace("data", "")
        .replace(/^.+,/, "");

      updateGroupFormImage(base64String, image.name);
    };

    reader.readAsDataURL(image);
  };

  const handleSubmit = () => {
    createGroup({
      onResponse,
      onError,
      body: {
        authenticity_token: authenticityToken,
        name: state?.groupForm?.name,
        description: state?.groupForm?.description,
        image: state?.groupForm?.image,
        image_file_name: state?.groupForm?.imageFileName,
      },
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Field label="Image" hint="Optional" id="group_image">
        <FileInput
          accept="image/png,image/gif,image/jpeg"
          onChange={(e) => {
            if (e.target.files[0]) {
              base64Image(e.target.files[0]);
            }
          }}
        />
      </Field>

      <Field label="Name" id="group_name">
        <Input
          type="text"
          value={state?.groupForm?.name || ''}
          onChange={(e) => {
            updateGroupFormName(e.target.value);
          }}
        />
      </Field>

      <Field label="Description" id="group_description">
        <Textarea
          value={state?.groupForm?.description || ''}
          onChange={(e) => {
            updateGroupFormDescription(e.target.value);
          }}
        />
      </Field>

      <ResponsiveContainer name="form-actions">
        <FormActions>
          <Button
            variant="secondary"
            onClick={() => {
              closeGroupModal();
            }}
          >
            Cancel
          </Button>
          <Button type="submit">
            Create
          </Button>
        </FormActions>
      </ResponsiveContainer>
    </Form>
  );
};

export default GroupForm;
